import React from "react";
import { styled } from "styled-components";

const ContentPageContainerElement = styled.main`
	padding: 3vh 7.5vw;
`

export const PrivacyPolicy = () => (
	<ContentPageContainerElement>
		<h1>Data Goes Where — Privacy Policy</h1>
		
		
		<p>The <i>Data Goes Where</i> browser extension collects data exclusively for your use.
			The extension sends <b>no</b> data to us. None. Nil. Squat. Zero. Zilch. Zip.</p>
		
	
		<p>Since we do not collect any of your data, we do not share your data with anyone. Nobody.
			We cannot share it because we do not have it.
		</p>
		
		<p>Why have a privacy policy that describes what we do with the data we collect if we do not collect any?
			Surveillance capitalists appear to have been unable to imagine that someone might ever make software
			for you, instead of to get data from you.
			So, we have to do the work to write a privacy policy for code that runs entirely on your computer and sends no data to us.
			At least we are having a good time doing it.
		</p>
		
		<p>Also, it gives us the opportunity to consider that, at some point,
			it might make sense for us to collect telemetry to make Data Goes Where work better for you.
			This is the point where the privacy policy would tell you that we reserve the right to notify that we are changing these terms terms at any time.
			That doesn't seem cool, though.
			If we have a good reason to start collecting data we will (imagine this!) <b>ask your permission first</b>.</p>
	</ContentPageContainerElement>);

export const DataGoesWhereHomePage = () => (<>
</>);